import config from './app';

export { default as theme } from './theme';
export { default as AppLocale } from './translation';

export default config;
